var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.353,
    height: 77,
    viewBox: "0 0 80.353 77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34010",
    "data-name": "Group 34010",
    transform: "translate(67.749 -38.372)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72231",
    "data-name": "Path 72231",
    d: "M-56.674,112.872H1.464a8.643,8.643,0,0,0,8.641-8.644V69.33A8.64,8.64,0,0,0,1.464,60.69H-39.092a8.385,8.385,0,0,0-8.386,8.386v34.911a8.885,8.885,0,0,1-8.885,8.885h0a8.885,8.885,0,0,1-8.885-8.885V49.516a8.645,8.645,0,0,1,8.644-8.644H-37.6a7.705,7.705,0,0,1,5.636,2.455l6.684,7.2H-8.941A8.64,8.64,0,0,1-.3,59.164V60.69",
    transform: "translate(0)",
    fill: "none",
    stroke: "#263757",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5420",
    "data-name": "Line 5420",
    y2: 19.934,
    transform: "translate(-18.728 76.699)",
    fill: "none",
    stroke: "#263757",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5421",
    "data-name": "Line 5421",
    x1: 19.934,
    transform: "translate(-28.695 86.666)",
    fill: "none",
    stroke: "#263757",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFolder);
export default __webpack_public_path__ + "static/media/add-folder.3c6cac36775dfc68f3ee4977efd35536.svg";
export { ForwardRef as ReactComponent };